import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import ChangeAccountPasswordButton from "./ChangeAccountPasswordButton";

const useStyles = makeStyles({
    root: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});


const AdminChangeAccountPassword = ({userAccount}) => {
    const classes = useStyles();

    return (
        <Card className={classes.root} variant="outlined">
            <CardContent>
                <Typography variant="h5" component="h2">
                    Change Password
                </Typography>

                <Typography className={classes.pos} color="textSecondary">
                    Directly set a new password for this account
                </Typography>

                <ChangeAccountPasswordButton userAccount={userAccount}/>
            </CardContent>
        </Card>
    );
};

export default AdminChangeAccountPassword;